import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/user.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-download-tax-return',
  templateUrl: './download-tax-return.component.html',
  styleUrls: ['./download-tax-return.component.css']
})
export class DownloadTaxReturnComponent implements OnInit {
  p: number = 1; 
  ramki: any; 
  public downloadTaxReturn:any;
  config: any;
  fileName: any;
  ID: any;
  constructor(public usr:UserService,
              public router:Router,
              public toastr:ToastrService,
              private httpClient: HttpClient) {
              let b =JSON.parse(localStorage.getItem('data'));
              this.ramki = b;
   }

  ngOnInit(): void {
    this.ID = JSON.parse(localStorage.getItem('data'));
    this.config = {
      itemsPerPage: 5,
      currentPage: 1
    };
    let obj ={
      "user_id":`${this.ramki.user_id}`
    };
    this.usr.downloadTaxReturn(obj).subscribe((res:any)=>
    {
      if(res.code===200)
      {
        this.downloadTaxReturn=res.data;
      }else if(res.code===402){
        this.toastr.error(res.message);
      }
      else {
        console.log(res.message);
      }
    }, (err)=>{
      console.log(err);
    });
  }

  pageChanged(event) {
    this.config.currentPage = event;
  }

  downloadFile(files: any) {
    // console.log("File Downloaded", files);
    let obj={
      "user_id":this.ID.user_id,
      "file_name":files
    }
    let baseUrl = "https://9h6bwbaajf.execute-api.ap-south-1.amazonaws.com/dev/";
    // let baseUrl = "http://192.168.1.104:2528/";
    this.httpClient.post(baseUrl + "retax_fileDownload",obj).subscribe((res:any) => {
      if(res.code===200)
      {
        this.toastr.success(res.message);
      }else {
        this.toastr.error(res.message);
      }
      
    }, (err => console.error('er', err)))
}
}
